import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';

import {
  resetCurrentDieSizePage,
  resetDieSizeList,
  fetchDieSizeDropdown,
} from './../../slices/die-size';
import {
  fetchVendorDropdown,
  resetCurrentVendorPage,
  resetVendorList,
} from '../../slices/vendor';
import {
  fetchBlosterDropdown,
  resetCurrentBlosterPage,
  resetBlosterList,
} from '../../slices/bolster';
import {
  fetchDieToolById,
  fetchDieToolDetails,
  updateDieTool,
} from './../../slices/die-tool';
import {
  fetchDiePressDropdown,
  resetDiePressList,
  resetCurrentDiePressPage,
} from './../../slices/die-press';

import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { debounce } from 'lodash';

const { Option } = Select;

function EditDieTool() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const { id } = useParams();
  const [dieType, setDieType] = useState(null);
  const [searchGroup, setSearchGroup] = useState('');
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedPress, setSelectedPress] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchDieSize, setSearchDieSize] = useState('');
  const [searchDeveloper, setSearchDeveloper] = useState('');
  const [searchBloster, setSearchBloster] = useState('');
  const [runUnderDeviation, setRunUnderDeviation] =
    useState('under development');
  const [runUnderDeviationReason, setRunUnderDeviationReason] = useState('');
  const { data: settingData } = useSelector(state => state.setting);
  const {
    list: diePressList,
    list: diePressDropdown,
    loading: diePressLoading,
    currentpage: diePressCurrentPage,
    hasMore: diePressHasMore,
  } = useSelector(state => state.diePress);
  const [toolData, setToolData] = useState(); // Default value
  const [searchDiePress, setSearchDiePress] = useState('');
  const {
    list: dieProfileList,
    list: dieProfileDropdown,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: dieSizeList,
    list: dieSizeDropdown,
    loading: dieSizeLoading,
    currentPage: dieSizeCurrentPage,
    hasMore: dieSizeHasMore,
  } = useSelector(state => state.diesize);

  const {
    list: developerList,
    list: vendorDropdown,
    loading: developerLoading,
    currentPage: developerCurrentPage,
    hasMore: developerHasMore,
  } = useSelector(state => state.vendor);
  const {
    list: blosterList,
    list: blosterDropdown,
    loading: blosterLoading,
    currentPage: blosterCurrentPage,
    hasMore: blosterHasMore,
  } = useSelector(state => state.bloster);
  const [isOrderDateRequired, setIsOrderDateRequired] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [isReceivedDateRequired, setIsReceivedDateRequired] = useState(false);
  const [selectedSolidOption, setSelectedSolidOption] = useState(null);
  const [selectHollowOption, setSelectHollowOption] = useState(null);
  const [selectedDieProfile, setSelectedDieProfile] = useState(null);
  const [selectedVendor, setselectVendor] = useState(null);
  const [selectedBloster, setSelectBloster] = useState(null);
  const [selectedDiePress, setSelectDiePress] = useState(null);
  const [selectSemiHollowOption, setSelectSemiHollowOption] = useState(null);
  const hollowOptions = [
    { id: 'Full Set', name: 'Full Set' },
    { id: 'Die Plate', name: 'Die Plate' },
    { id: 'Mandril', name: 'Mandril' },
  ];
  const semiHollowOptions = [
    { id: 'Die Plate', name: 'Die Plate' },
    { id: 'Mandril', name: 'Mandril' },
  ];
  const solidOptions = [
    { id: 'Full Set', name: 'Full Set' },
    { id: 'Die Plate', name: 'Die Plate' },
    { id: 'Insert', name: 'Insert' },
  ];

  const getClassNameDieProfile = value => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedDieProfile,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNamePress = value => {
    const selected = diePressDropdown.find(
      item => item.id === selectedDiePress,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNameVendor = value => {
    const selected = vendorDropdown.find(item => item.id === selectedVendor);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNameBloster = value => {
    const selected = blosterDropdown.find(item => item.id === selectedBloster);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const handleSemiHoolowOptionChange = value => {
    setSelectSemiHollowOption(value);
    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };
  const handleSolidOptionChange = value => {
    setSelectedSolidOption(value);
    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleSearchSolidDie = value => {
    setSelectedSolidOption(value);
  };

  const handleDeviationChange = e => {
    const value = e.target.value;
    setRunUnderDeviation(value);
    if (value !== 'inactive') {
      setRunUnderDeviationReason('');
    }
    // If "Active" is selected, make received_date required
    if (value === 'active') {
      setIsReceivedDateRequired(true);
    } else {
      setIsReceivedDateRequired(false);
      // If moving away from Active, clear received_date
      if (form.getFieldValue('received_date')) {
        form.setFieldsValue({ received_date: null });
      }
    }
    // If "Active" is selected and no received_date, optionally focus the field (UX improvement)
    if (value === 'active' && !form.getFieldValue('received_date')) {
      // Optionally focus the field
    }
  }

  const handleHoolowOptionChange = value => {
    setSelectHollowOption(value);
    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleSearchHollowDie = value => {
    setSelectHollowOption(value);
  };
  const handleSearchDiePress = value => {
    setSearchDiePress(value);
    if (value) {
      setSearchDiePress(value);
      dispatch(resetDiePressList());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10, search: value }));
    } else {
      setSearchDiePress('');
      dispatch(resetDiePressList());
      dispatch(resetCurrentDiePressPage());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeDiePress = value => {
    setSearchDiePress(value);
    setSelectDiePress(value);
  };
  const onScrollDiePress = async event => {
    const target = event.target;
    if (
      !diePressLoading &&
      diePressHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDiePressDropdown({ page: diePressCurrentPage, pagesize: 10 }),
      );
    }
  };
  const handleReasonChange = e => {
    const value = e.target.value;
    setRunUnderDeviationReason(e.target.value);
    if (value !== 'other') {
      form.setFieldsValue({ run_under_deviation_reason: value });
    }
  };

  const getClassName = () => {
    const selected = dieSizeDropdown.find(item => item.id === selectedSize);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const handleDieProfileChange = (selected, value) => {
    setSelectedDieProfile(value);
    if (!selected) {
      form.setFieldsValue({
        tool_number: null,
        die_type: null,
        total_running_qty: null,
        total_running_ton: null,
        wt_kg_p_mt: null,
      });
      setSearchGroup(null); // Reset searchGroup state to clear the selected value
      return;
    }
    try {
      dispatch(fetchDieToolDetails(selected.label))
        .unwrap()
        .then(response => {
          if (response.success) {
            const fetchedDieType = response.data.die_type;
            setDieType(fetchedDieType);
            form.setFieldsValue({
              tool_number: response.data.tool_number,
              die_type: fetchedDieType,
              total_running_qty: response.data.total_running_qty,
              total_running_ton: response.data.total_running_ton,
              wt_kg_p_mt:
                response.data.tool_number === '1'
                  ? response.data.current_kg
                  : 0,
            });
          }
        })
        .catch(error => {
          console.error('');
        });
    } catch (error) {
      console.error('');
    }
  };
  const handleSearchDieGroup = value => {
    setSearchGroup(value);
    if (value) {
      dispatch(fetchDieToolDetails({ page: 1, pagesize: 1000, search: value }));
    } else {
      dispatch(fetchDieToolDetails({ page: 1, pagesize: 10 }));
    }
  };

  const handleFormChange = changedValues => {
    if ('received_date' in changedValues) {
      const orderDate = changedValues.received_date;
      if (orderDate) {
        form.setFieldsValue({ is_active: true });
        setIsCheckboxDisabled(true); // Check the checkbox
      } else {
        form.setFieldsValue({ is_active: false }); // Enable the checkbox if order_date is cleared
        setIsCheckboxDisabled(false);
      }
    }

    if ('is_active' in changedValues) {
      const isChecked = changedValues.is_active;
      if (isChecked) {
        setIsReceivedDateRequired(true); // Make order_date required
      } else {
        setIsReceivedDateRequired(false); // Remove required validation for order_date
      }
    }
  };
  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData()); // Reset the list when searching
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: value || '',
      }),
    );
  }, 300);
  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const onScrollDieProfile = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const handleSearchHSemiHollowDie = value => {
    setSelectSemiHollowOption(value);
  };
  const handleChangeDieSize = value => {
    setSearchDieSize(value);
    setSelectedSize(value);
  };
  const handleSearchDieSize = value => {
    setSearchDieSize(value);
    if (value) {
      setSearchDieSize(value);
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100 }));
    } else {
      setSearchDieSize('');
      dispatch(resetCurrentDieSizePage());
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleSearchDeveloper = value => {
    setSearchDeveloper(value);

    if (value) {
      setSearchDeveloper(value);
      dispatch(resetVendorList());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDeveloper('');
      dispatch(resetVendorList());
      dispatch(resetCurrentVendorPage());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeDeveloper = value => {
    setselectVendor(value);
    setSearchDeveloper(value);
  };

  const handleSearchBloster = value => {
    setSearchBloster(value);

    if (value) {
      setSearchBloster(value);
      dispatch(resetBlosterList());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchBloster('');
      dispatch(resetBlosterList());
      dispatch(resetCurrentBlosterPage());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeBloster = value => {
    setSearchBloster(value);
    setSelectBloster(value);
  };

  useEffect(() => {
  const fetchDieTool = async () => {
    try {
      const response = await dispatch(fetchDieToolById(id)).unwrap();

      // Normalize data: handle both array and single-object responses
      let data = response?.data ?? response?.data ?? response;
      if (Array.isArray(data)) {
        if (data.length === 0) return;
        data = data[0];
      }
      if (!data) return;

      const dieTool = data;

      // Safe reads with optional chaining
      const die = dieTool?.die ?? null;
      const fetchDieType = die?.die_type ?? null;

      setDieType(fetchDieType);
      setToolData(dieTool);
      setRunUnderDeviation(dieTool?.run_under_deviation ?? null);
      setRunUnderDeviationReason(dieTool?.run_under_deviation_reason ?? null);

      const selectedPressId = dieTool?.eligible_for_press?.id ?? null;
      setSelectedPress(selectedPressId);

      // Die option selection depending on type
      if (fetchDieType === 'Solid') {
        setSelectedSolidOption(dieTool?.die_option ?? null);
      } else if (fetchDieType === 'Hollow') {
        setSelectHollowOption(dieTool?.die_option ?? null);
      } else if (fetchDieType === 'Semi Hollow') {
        setSelectSemiHollowOption(dieTool?.die_option ?? null);
      } else {
        // clear previous options if type unknown
        setSelectedSolidOption(null);
        setSelectHollowOption(null);
        setSelectSemiHollowOption(null);
      }

      // run_under_deviation flag logic
      setIsReceivedDateRequired(dieTool?.run_under_deviation === 'active');

      // Build safe fields object for setFieldsValue
      const fields = {
        die: dieTool?.die?.id ?? null,
        current_kg: dieTool?.current_kg ?? null,
        tool_number: dieTool?.tool_number ?? null,
        die_size: dieTool?.die_size?.id ?? null,
        die_cavity: dieTool?.die_cavity ?? null,
        developer: dieTool?.developer?.id ?? null,
        die_type: fetchDieType,
        backer_number: dieTool?.backer_number ?? null,
        die_option: dieTool?.die_option ?? null,
        diameter: dieTool?.diameter ?? null,
        thickness: dieTool?.thickness ?? null,
        row_no: dieTool?.row_no ?? null,
        rac_no: dieTool?.rac_no ?? null,
        column_no: dieTool?.column_no ?? null,
        die_location: `${dieTool?.row_no ?? ''} / ${dieTool?.rac_no ?? ''} / ${dieTool?.column_no ?? ''}`.trim(),
        developer_ref_no: dieTool?.developer_ref_no ?? null,
        received_date: dieTool?.received_date ? dayjs(dieTool.received_date, 'YYYY-MM-DD') : null,
        order_date: dieTool?.order_date ? dayjs(dieTool.order_date, 'YYYY-MM-DD') : null,
        total_running_qty: dieTool?.total_running_qty ?? null,
        total_running_ton: dieTool?.total_running_ton ?? null,
        drawing_no: dieTool?.drawing_no ?? null,
        eligible_bloster: dieTool?.eligible_bloster?.id ?? null,
        eligible_for_press: selectedPressId,
        purchase_price: dieTool?.purchase_price ?? null,
        run_under_deviation: dieTool?.run_under_deviation ?? null,
        run_under_deviation_inactive: dieTool?.run_under_deviation_inactive ?? null,
        run_under_deviation_reason: dieTool?.run_under_deviation_reason ?? null,
        ownership: dieTool?.ownership ?? null,
        is_active: dieTool?.is_active ?? null,
        remarks: dieTool?.remarks ?? null,
      };

      form.setFieldsValue(fields);

      // Set UI selections safely
      setSelectedDieProfile(dieTool?.die?.id ?? null);
      setSelectedSize(dieTool?.die_size?.id ?? null);
      setselectVendor(dieTool?.developer?.id ?? null);
      setSelectBloster(dieTool?.eligible_bloster?.id ?? null);
      setSelectDiePress(selectedPressId);

      if (dieTool?.order_date) {
        setIsCheckboxDisabled(true);
      }
    } catch (error) {
      console.error('Error fetching die tool:', error);
    }
  };

  fetchDieTool();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [id, form]); // keep dependencies minimal; if form is stable object, fine

  const onScrollDieSize = async event => {
    const target = event.target;
    if (
      !dieSizeLoading &&
      dieSizeHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDieSizeDropdown({ page: dieSizeCurrentPage, pagesize: 10 }));
    }
  };
  const onScrollDeveloper = async event => {
    const target = event.target;
    if (
      !developerLoading &&
      developerHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchVendorDropdown({ page: developerCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollBloster = async event => {
    const target = event.target;
    if (
      !blosterLoading &&
      blosterHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchBlosterDropdown({ page: blosterCurrentPage, pagesize: 10 }));
    }
  };

  useEffect(() => {
    dispatch(resetDieProfileList());
    dispatch(resetDieSizeList());
    dispatch(resetVendorList());
    dispatch(resetBlosterList());
    dispatch(resetDiePressList());
    dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchVendorDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchBlosterDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchDiePressDropdown({ page: 1, pagesize: 50000 }));
  }, []);

  const handleReceivedDateChange = (date, dateString) => {
    form.setFieldsValue({ received_date: date });
    if (date) {
      setRunUnderDeviation('active');
      setIsReceivedDateRequired(true);
      form.setFieldsValue({ run_under_deviation: 'active', is_active: true });
    } else {
      setRunUnderDeviation('under development');
      setIsReceivedDateRequired(false);
      form.setFieldsValue({ run_under_deviation: 'under development', is_active: false });
    }
  };

  const handleOrderDateChange = (date, dateString) => {
    form.setFieldsValue({ order_date: date });
  };

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedValues = {
      ...values,
      order_date: values.order_date.format('YYYY-MM-DD'),
      received_date: values.received_date
        ? values.received_date.format('YYYY-MM-DD')
        : null,
    };
    values = formattedValues;

    dispatch(updateDieTool({ id: id, values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Die Tool Updated Successfully!');
          navigate('/die-tool');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const onFinishFailed = errorInfo => { };

  const handleFieldChange = () => {
    const rackNo = form.getFieldValue('rac_no') || '';
    const rowNo = form.getFieldValue('row_no') || '';
    const columnNo = form.getFieldValue('column_no') || '';
    const dieLocation = `${rackNo} / ${rowNo} / ${columnNo}`;
    form.setFieldsValue({ die_location: dieLocation });
  };

  return (
    <>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Edit Die Tool</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/die-tool">Die Tools</Link> },
                  { title: 'Edit Die Tool' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onValuesChange={handleFormChange}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Section No"
                  name="die"
                  rules={[
                    { required: true, message: 'Please select a Section No' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Profile No"
                    style={{ width: '100%' }}
                    onChange={handleDieProfileChange}
                    labelInValue={true}
                    loading={dieProfileLoading}
                    onPopupScroll={onScrollDieProfile}
                    value={searchGroup ? { value: searchGroup } : undefined} // Ensure this is in the correct shape
                    notFoundContent={
                      dieProfileLoading ? 'Loading...' : 'No options'
                    }
                    showSearch={true}
                    onSearch={handleSearchDieProfile}
                    allowClear
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className={getClassNameDieProfile()}
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {[
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                    {dieProfileLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
               <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Tool Number"
                  name="tool_number"
                  rules={[
                    { required: true, message: 'Please enter tool number' }
                  ]}
                >
                  <Input placeholder="Enter Tool Number" />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Current Kg / Mtr"
                  name="current_kg"
                  rules={[
                    { required: true, message: 'Please enter tool number' },
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input
                    placeholder="Current Kg / Mtr"
                    maxLength={15}
                  />
                </Form.Item>
              </Col>
             

              {dieType === 'Hollow' && (
                <Col xs={12} sm={8} xl={6} xxl={4}>
                  <Form.Item
                    name="die_option"
                    label="Hollow Die Option"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a hollow die option',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Hollow Die Option"
                      onChange={handleHoolowOptionChange}
                      onSearch={handleSearchHollowDie}
                      showSearch={true}
                      value={
                        selectHollowOption
                          ? {
                            value: selectHollowOption,
                            label: hollowOptions.find(
                              item => item.id === selectHollowOption,
                            )?.name,
                          }
                          : undefined
                      }
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          hollowOptions.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
              )}
              {selectHollowOption === 'Die Plate' && (
                <Col xs={12} sm={8} xl={6} xxl={4}>
                  <Form.Item
                    name="backer_number"
                    label="Backer Number"
                    rules={[
                      {
                        pattern: /^[a-zA-Z0-9]*$/,
                        message: 'Only alphanumeric characters are allowed.',
                      },
                    ]}
                  >
                    <Input placeholder="Backer Number"></Input>
                  </Form.Item>
                </Col>
              )}
              {dieType === 'Semi Hollow' && (
                <Col xs={12} sm={8} xl={6} xxl={4}>
                  <Form.Item
                    name="die_option"
                    label="Semi Hollow Die Option"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a semi hollow die option',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Select Semi Hollow Die Option"
                      onChange={handleHoolowOptionChange}
                      onSearch={handleSearchHSemiHollowDie}
                      showSearch={true}
                      value={selectSemiHollowOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          semiHollowOptions.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
              )}
              {selectHollowOption === 'Mandril' && (
                <>
                  <Col xs={12} sm={8} xl={6} xxl={4}>
                    <Form.Item
                      name="diameter"
                      label="Diameter"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter diameter',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Diameter" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={8} xl={6} xxl={4}>
                    <Form.Item
                      name="thickness"
                      label="Thickness"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter thickness',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Thickness" />
                    </Form.Item>
                  </Col>
                </>
              )}

              {selectSemiHollowOption === 'Die Plate' && (
                <Col xs={12} sm={8} xl={6} xxl={4}>
                  <Form.Item
                    name="backer_number"
                    label="Backer Number"
                    rules={[
                      {
                        pattern: /^[a-zA-Z0-9]*$/,
                        message: 'Only alphanumeric characters are allowed.',
                      },
                    ]}
                  >
                    <Input placeholder="Backer Number"></Input>
                  </Form.Item>
                </Col>
              )}
              {selectSemiHollowOption === 'Mandril' && (
                <>
                  <Col xs={12} sm={8} xl={6} xxl={4}>
                    <Form.Item
                      name="diameter"
                      label="Diameter"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter diameter',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Diameter" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} xl={8} xxl={4}>
                    <Form.Item
                      name="thickness"
                      label="Thickness"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter thickness',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Thickness" />
                    </Form.Item>
                  </Col>
                </>
              )}
              {dieType === 'Solid' && (
                <Col xs={12} sm={8} xl={6} xxl={4}>
                  <Form.Item
                    name="die_option"
                    label="Solid Die Option"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a solid die option',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Solid Die Option"
                      onChange={handleSolidOptionChange}
                      onSearch={handleSearchSolidDie}
                      showSearch={true}
                      value={selectedSolidOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          solidOptions.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
              )}
              {selectedSolidOption === 'Die Plate' && (
                <Col xs={12} sm={8} xl={6} xxl={4}>
                  <Form.Item
                    name="backer_number"
                    label="Backer Number"
                    rules={[
                      {
                        pattern: /^[a-zA-Z0-9]*$/,
                        message: 'Only alphanumeric characters are allowed.',
                      },
                    ]}
                  >
                    <Input placeholder="Backer Number"></Input>
                  </Form.Item>
                </Col>
              )}

              {selectedSolidOption === 'Insert' && (
                <>
                  <Col xs={12} sm={8} xl={6} xxl={4}>
                    <Form.Item
                      name="diameter"
                      label="Diameter"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter diameter',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Diameter" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={8} xl={6} xxl={4}>
                    <Form.Item
                      name="thickness"
                      label="Thickness"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter thickness',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Thickness" />
                    </Form.Item>
                  </Col>
                </>
              )}
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Die Size (MM)"
                  name="die_size"
                  rules={[{ required: true, message: 'Please select die size' }]}
                >
                  <AutoOpenSelect
                    placeholder="Select Die Size"
                    style={{ width: '100%' }}
                    loading={dieSizeLoading}
                    onPopupScroll={onScrollDieSize}
                    notFoundContent={
                      dieSizeLoading ? 'Loading...' : 'No options'
                    }
                    showSearch={true}
                    value={searchDieSize}
                    onChange={handleChangeDieSize}
                    onSearch={handleSearchDieSize}
                    allowClear
                    filterOption={(input, option) => {
                      if (!input) return true; // Show all options if input is empty
                      const optionText = (option?.children || '')
                        .toString()
                        .replace(/\s+/g, '')
                        .toLowerCase();
                      const inputText = input.replace(/\s+/g, '').toLowerCase();
                      return optionText.includes(inputText);
                    }}
                    dropdownRender={menu => <>{menu}</>}
                    className={getClassName()}
                  >
                    {[
                      ...new Map(
                        dieSizeDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map(el => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_width} X {el.die_height}
                      </Option>
                    ))}
                    {dieSizeLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Die Cavity"
                  name="die_cavity"
                  rules={[
                    { required: true, message: 'Please enter die cavity' },
                    {
                      validator: (_, value) => {
                        if (!value || parseInt(value, 10) <= 10) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'Ensure this value is less than or equal to 10.',
                          ),
                        );
                      },
                    },
                  ]}
                >
                  <Input placeholder="Enter Die Cavity" />
                </Form.Item>
              </Col>

              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item name="eligible_for_press" label="Eligible For Press">
                  <AutoOpenSelect
                    placeholder="Select Press"
                    loading={diePressLoading}
                    onPopupScroll={onScrollDiePress}
                    notFoundContent={
                      diePressLoading ? 'Loading...' : 'No options'
                    }
                    value={searchDiePress}
                    className={getClassNamePress()}
                    showSearch={true}
                    onSearch={handleSearchDiePress}
                    onChange={handleChangeDiePress}
                    allowClear
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {diePressDropdown.map(el => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.name}
                      </Option>
                    ))}
                    {diePressLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Rack No"
                  name="rac_no"
                  rules={[
                    { required: true, message: 'Please enter rack number' },
                    {
                      pattern: /^[0-9]+(\.[0-9]*)?$/,
                      message: 'Only numeric values are allowed',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Rack Number"
                    onChange={handleFieldChange}
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Row No"
                  name="row_no"
                  rules={[
                    { required: true, message: 'Please enter row no.' },
                    {
                      pattern: /^[A-Z\s]+$/,
                      message: 'Only uppercase & alphabets are allowed',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Raw No."
                    onChange={e => {
                      const upperCaseValue = e.target.value.toUpperCase();
                      handleFieldChange({
                        ...e,
                        target: { ...e.target, value: upperCaseValue },
                      });
                      form.setFieldsValue({ row_no: upperCaseValue });
                    }}
                    maxLength={30}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Column No"
                  name="column_no"
                  rules={[
                    { required: true, message: 'Please enter column number' },
                    {
                      pattern: /^[0-9]+(\.[0-9]*)?$/,
                      message: 'Only numeric values are allowed',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Column No."
                    onChange={handleFieldChange}
                    maxLength={15}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Die Location"
                  name="die_location"
                  rules={[
                    { required: false, message: 'Please enter die location' },
                  ]}
                >
                  <Input placeholder="Enter Die Location" disabled />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Vendor"
                  name="developer"
                  rules={[
                    { required: true, message: 'Please select developer name' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Vendor Name"
                    style={{ width: '100%' }}
                    loading={developerLoading}
                    onPopupScroll={onScrollDeveloper}
                    notFoundContent={
                      developerLoading ? 'Loading...' : 'No options'
                    }
                    value={searchDeveloper}
                    showSearch={true}
                    onSearch={handleSearchDeveloper}
                    className={getClassNameVendor()}
                    onChange={handleChangeDeveloper}
                    allowClear
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {vendorDropdown.map(el => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {`${el.vendor_trade_name}`}
                      </Option>
                    ))}
                    {developerLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Developer Ref. No "
                  name="developer_ref_no"
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter Developer Reference Number',
                    },
                  ]}
                >
                  <Input
                    placeholder="Developer Ref. No"
                    maxLength={30}
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ developer_ref_no: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[
                    { required: true, message: 'Please select order date' },
                  ]}
                >
                  <DatePicker
                    placeholder="Select Date"
                    format="DD-MM-YYYY"
                    showTime={false}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label={
                    <span>
                      Received Date&nbsp;
                      <Tooltip title="The die tool is automatically activated if you select this date. Otherwise it is inactive.">
                        <InfoCircleOutlined
                          style={{ color: '#123B66', cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </span>
                  }
                  name="received_date"
                  rules={
                    isReceivedDateRequired
                      ? [
                        {
                          required: true,
                          message: 'Please select order date',
                        },
                      ]
                      : []
                  }
                >
                  <DatePicker
                    placeholder="Select Date"
                    format="DD-MM-YYYY"
                    showTime={false}
                    style={{ width: '100%' }}
                    onChange={handleReceivedDateChange}
                    value={form.getFieldValue('received_date')}
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  name="total_running_qty"
                  label="Total Running Kilometer"
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                  ]}
                >
                  <Input placeholder="Enter Kilometer" disabled />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  name="total_running_ton"
                  label="Total Running Metric Ton"
                  colon={false}
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                  ]}
                >
                  <Input placeholder="Enter Metric Ton" disabled />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label={
                    <span>
                      Drawing No.&nbsp;
                      <Tooltip title="Drawing No.">
                        <InfoCircleOutlined
                          style={{ color: '#123B66', cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </span>
                  }
                  rules={[
                    {
                      pattern: /^[A-Za-z0-9 ]*$/,
                      required: true,
                      message:
                        'Only alphabets, numbers, and spaces are allowed',
                    },
                  ]}
                  name="drawing_no"
                >
                  <Input
                    placeholder="Enter Drawing No."
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ drawing_no: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Purchase Price"
                  name="purchase_price"
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                  ]}
                >
                  <Input placeholder="Enter Purchase Price" maxLength={10} />
                </Form.Item>
              </Col>
              {/* <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Die Received Status"
                  name="is_active"
                  valuePropName="checked"
                >
                  <Checkbox disabled={isCheckboxDisabled}>Is Active</Checkbox>
                </Form.Item>
              </Col> */}
            </Row>
          </div>
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item label="Eligible Bolster" name="eligible_bloster">
                  <AutoOpenSelect
                    placeholder="Select Bolster"
                    style={{ width: '100%' }}
                    loading={blosterLoading}
                    onPopupScroll={onScrollBloster}
                    notFoundContent={
                      blosterLoading ? 'Loading...' : 'No options'
                    }
                    value={searchBloster}
                    className={getClassNameBloster()}
                    onChange={handleChangeBloster}
                    onSearch={handleSearchBloster}
                    showSearch={true}
                    allowClear
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {blosterDropdown.map(el => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.bloster_no}
                      </Option>
                    ))}
                    {blosterLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Ownership"
                  name="ownership"
                  rules={[{ required: true, message: 'Please select an option' }]}
                >
                  <Radio.Group>
                    <Radio value="own">{settingData?.company_settings?.company_name}</Radio>
                    <Radio value="customer">Customer</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} xl={12} xxl={16}>
                <Form.Item
                  label="Tool Status"
                  name="run_under_deviation"
                  rules={[{ required: true, message: 'Please select an option' }]}
                >
                  <Radio.Group
                    onChange={e => {
                      handleDeviationChange(e);
                      // Set is_active in form based on selection
                      if (e.target.value === 'active') {
                        form.setFieldsValue({ is_active: true });
                      } else {
                        form.setFieldsValue({ is_active: false });
                      }
                    }}
                    value={runUnderDeviation}
                  >
                    <Radio value="active">Active</Radio>
                    <Radio value="inactive">Inactive</Radio>
                    <Radio value="under development">Under Development</Radio>
                  </Radio.Group>
                  {runUnderDeviation === 'inactive' && (
                    <div>
                      <Form.Item
                        label="Reason"
                        name="run_under_deviation_inactive"
                        rules={[
                          { required: true, message: 'Please select a reason!' },
                        ]}
                      >
                        <Radio.Group
                          onChange={handleReasonChange}
                          value={runUnderDeviationReason}
                        >
                          <Radio value="die_broken">Die Broken</Radio>
                          <Radio value="die_absolute">Die Absolute</Radio>
                          <Radio value="die_shift">Die Shift</Radio>
                          <Radio value="other">Other</Radio>
                        </Radio.Group>
                      </Form.Item>
                      {form.getFieldValue('run_under_deviation_inactive') ===
                        'other' && (
                          <Form.Item
                            name="run_under_deviation_reason"
                            rules={[
                              {
                                required: true,
                                message: 'Please specify the reason',
                              },
                            ]}
                          >
                            <Input
                              style={{ marginTop: '8px' }}
                              placeholder="Specify other reason"
                              onChange={e => {
                                const value = e.target.value;
                                const formattedValue = value
                                  .toLowerCase()
                                  .replace(/\b\w/g, char => char.toUpperCase());
                                form.setFieldsValue({
                                  run_under_deviation_reason: formattedValue,
                                }); // Update Form state
                              }}
                            />
                          </Form.Item>
                        )}
                    </div>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </div>

          <Form.Item label="Remarks" name="remarks">
            <Input.TextArea
              rows={4}
              placeholder="Write a remark, maximum 150 characters"
              maxLength={150}
              onChange={e => {
                const value = e.target.value;
                const formattedValue = value
                  .toLowerCase()
                  .replace(/\b\w/g, char => char.toUpperCase());
                form.setFieldsValue({ remarks: formattedValue }); // Update Form state
              }}
            />
          </Form.Item>

          <div className="flex justify-end">
            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                icon={<PlusOutlined />}
              >
                Edit Tool
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditDieTool;
